import React from 'react';
import './ChallengeView.css';

const ChallengesSection = () => (
  <div style={{ textAlign: 'center', marginTop: '3rem' }}>
    <a
      href="https://uottahack8.devpost.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontSize: '2rem',
        color: '#fff',
        background: 'linear-gradient(90deg, #43cea2 0%, #185a9d 100%)',
        padding: '1.2rem 2.5rem',
        borderRadius: '2.5rem',
        textDecoration: 'none',
        fontWeight: 700,
        boxShadow: '0 4px 24px 0 rgba(30, 144, 255, 0.15)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        display: 'inline-block',
        letterSpacing: '0.02em',
      }}
      onMouseOver={e => {
        (e.currentTarget as HTMLAnchorElement).style.transform = 'scale(1.04)';
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 8px 32px 0 rgba(30, 144, 255, 0.25)';
      }}
      onMouseOut={e => {
        (e.currentTarget as HTMLAnchorElement).style.transform = 'none';
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 24px 0 rgba(30, 144, 255, 0.15)';
      }}
    >
      View all challenges and details on Devpost
    </a>
  </div>
);

const ChallengeView: React.FC = () => {
  return (
    <div id="challenge-view">
      <ChallengesSection />
    </div>
  );
};

export default ChallengeView;